import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalReportsNav4Route: InvariantJiraRoute = {
	name: 'eoc-global-report-dashboard',
	path: '/jira/ops/reports/:dashboardId',
	exact: true,
};
